import type { AssetDuplicateFormProps } from "./asset-duplicate-form.type";

import { ModelDuplicateForm } from "@/modules/model-duplicate";

import { useAssetDuplicateForm } from "./asset-duplicate-form.hook";

const AssetDuplicateForm = (props: AssetDuplicateFormProps) => {
  const {
    form,
    formId,
    initialValues,
    onFormSubmit,
    isPending,
    validation,
    validationErrors,
  } = useAssetDuplicateForm(props);

  return (
    <ModelDuplicateForm
      form={form}
      formId={formId}
      initialValues={initialValues}
      onFormSubmit={onFormSubmit}
      loading={isPending}
      validation={validation}
      validationErrors={validationErrors}
    />
  );
};

export default AssetDuplicateForm;
